export const CLAIMS_LOADING = 'CLAIMS_LOADING';
export const CLAIMS_LOADED = 'CLAIMS_LOADED';
export const CLAIM_LOADING = 'CLAIM_LOADING';
export const CLAIM_LOADED = 'CLAIM_LOADED';
export const STATS_LOADING = 'STATS_LOADING';
export const STATS_LOADED = 'STATS_LOADED';